import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup,  FormBuilder} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {StaffsService} from '../../../service/staff/service-staffs';

import {Staffs} from '../../../models/staff/staffs';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {WorkGroupStaffsService} from '../../../service/staff/service-workgroupstaffs';
import {GroupSelectComponent} from '../group/groupselect.component';

@Component({
  templateUrl: './workgroupstaff.component.html'

})export class WorkGroupStaffsComponent implements OnInit {
  public language = language;

  public id: number = 0;
  public onClose: Subject<boolean>;
  public staffList: Staffs[]= [];
  public staffSelectList: Object[]=[];
  public selectedList: Object[]=[];
  constructor( public staffsService: StaffsService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public workGroupStaffsService: WorkGroupStaffsService

  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  public showReceive()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      for(let i=0; i< result.length;i++)
      {
        if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
          this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
          this.selectedList= [...this.selectedList, result[i].id];
        }
      }
      this.workGroupStaffsService.insertMulti(this.id, this.selectedList.join()).subscribe(
        {
          next: (data) => {
            this.toastr.success( language.add_success_record , language.message);
            this.search();
          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
    });
  }
  deleteItem(id: number)
  {
    this.workGroupStaffsService.deleteByGroupAndStaff(this.id, id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public search()
  {
    this.staffsService.findAllByWorkGroupId(this.id.toString()).pipe(first())
      .subscribe(x => {
        this.staffList = x;
        for(let i=0; i< x.length; i++)
        {
          this.staffSelectList= [...this.staffSelectList, {id: x[i].id, fullName: x[i].fullName}];

        }

      });
  }
  edit(id: number) {
    this.id = id;
    this.search();

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
